import { zodResolver } from '@hookform/resolvers/zod';
import { Grid } from '@mui/material';
import type { LoginRequestPayload } from '@weft/api-definition';
import { LoginRequestSchema } from '@weft/api-definition';
import { login } from 'apps/app/src/services/user-auth';
import { Helmet } from 'react-helmet';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useLocation } from 'react-router-dom';
import { useVyNavigate } from '../../../hooks/use-vy-navigate';
import { LoginPageForm } from './login-page-components/LoginPageForm';

export const LoginPage: React.FC = () => {
  const navigate = useVyNavigate();
  const { state } = useLocation();

  const methods = useForm<LoginRequestPayload>({
    resolver: zodResolver(LoginRequestSchema),
  });

  const loginMutation = useMutation(login, {
    onSuccess: () => {
      const path = state?.from?.pathname ?? '/';
      navigate(path);
    },
  });

  const handleSubmit = methods.handleSubmit(async (data) => {
    await loginMutation.mutateAsync(data);
  });
  
  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Grid
        container
        style={{ height: '100vh', overflow: 'hidden' }}
      >
        <Grid
          item
          lg={5}
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit}>
              <LoginPageForm/>
            </form>
          </FormProvider>
        </Grid>

        <Grid
          item
          display={{ xs: 'none', lg: 'flex' }}
          lg={7}
          sx={{
            background: 'linear-gradient(to bottom, #492f84, #36336a, #111d2d)',
            justifyContent: 'flex-end',
            overflow: 'hidden',
          }}
        >
          <img
            src="/assets/images/login-background.webp"
            alt="Vayu login background"
            style={{  
              maxWidth: '100vw',
              maxHeight: '100vh',
              userSelect: 'none', 
              pointerEvents: 'none',
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
